import React from "react"

// =============================================================================
// Props
// =============================================================================

export type KitLogoProps = {
  className?: string
}

// =============================================================================
// Component
// =============================================================================

/**
 * The Kit logo.
 *
 * Inherits `color` from its parent.
 */
export function KitLogo({ className }: KitLogoProps) {
  return (
    <svg
      className={className}
      width="400"
      height="182"
      viewBox="0 0 400 182"
      aria-hidden="true"
    >
      <path
        fill="currentColor"
        d="M109.562 75.903c49.21 9.535 64.488 55.097 64.903 100.93a1.873 1.873 0 0 1-1.86 1.878h-61.959c-1.03 0-1.86-.831-1.86-1.842-.181-35.557-5.942-66.925-41.174-68.28a1.863 1.863 0 0 0-1.932 1.86v66.42c0 1.029-.831 1.86-1.86 1.86H1.86c-1.03 0-1.86-.831-1.86-1.86V7.587c0-1.03.83-1.86 1.86-1.86h61.978c1.029 0 1.86.83 1.86 1.86V70.99c0 .939.758 1.698 1.697 1.698.74 0 1.409-.488 1.625-1.192 15.946-52.298 45.761-65.445 94.176-65.752 1.03 0 1.86.83 1.86 1.86v63.242c0 1.029-.83 1.86-1.86 1.86h-53.327c-.903 0-1.625.722-1.625 1.625 0 .758.56 1.427 1.318 1.571m169.661 39.639V74.549c0-1.03.831-1.86 1.861-1.86h45.598c.903 0 1.625-.723 1.625-1.626 0-.776-.56-1.445-1.318-1.589-35.684-7.079-52.154-27.612-52.714-61.887a1.827 1.827 0 0 1 1.824-1.86h66.962c1.029 0 1.86.83 1.86 1.86v28.876c0 1.03.831 1.86 1.86 1.86h38.393c1.029 0 1.86.83 1.86 1.86v30.682c0 1.029-.831 1.86-1.86 1.86h-38.393c-1.029 0-1.86.83-1.86 1.86v33.065c0 11.684 7.169 15.531 16.686 15.531 14.917 0 29.653-6.718 35.558-9.77 1.228-.632 2.709.253 2.709 1.643v51.467a3.74 3.74 0 0 1-1.969 3.287c-5.833 3.07-23.855 11.576-44.46 11.576-42.456-.036-74.222-17.319-74.222-65.842m-87.169 61.309V74.549c0-1.03.831-1.86 1.86-1.86h61.978c1.029 0 1.86.83 1.86 1.86V176.85c0 1.029-.831 1.86-1.86 1.86h-61.978c-1.029-.018-1.86-.849-1.86-1.86m-3.521-144.56c0 17.409 12.298 31.53 35.918 31.53 23.621 0 35.919-14.121 35.919-31.53S248.09.761 224.451.761c-23.62 0-35.918 14.122-35.918 31.53"
      />
    </svg>
  )
}
